import { PageQueryResult } from '@core/type/sanity';

import { ERouting, ViewCMSProps } from '../../../../../core-type/src';
import { makeServerProps } from '../../helpers/make-server-props/make-server-props';
import { useCMSPage } from '../../hooks/use-cms-page';
import { PageSanityContent } from '../../layout';

export type PagesProps = ViewCMSProps<PageQueryResult>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Pages = (props: PagesProps) =>
  useCMSPage<PageQueryResult>({
    ...props,
    ViewPage: PageSanityContent,
  });

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.PAGES,
  hasSanity: true,
});

export { getServerSideProps };

export default Pages;
